import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	label: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.xs,
		paddingLeft: THEME.spacing.none,
	},
	labelInvalid: {
		color: THEME.colors.danger.main,
	},
	requiredMark: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.md,
		marginLeft: THEME.spacing.xs,
	},
	helpText: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	informationalLabel: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	optionsGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	optionRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	selectTrigger: {
		width: '100%',
	},
});
